module.exports = __webpack_public_path__ + "da85a6b7db4455145cef569a0bd518bb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-31.png
// module id = 3123
// module chunks = 0